module.exports = __webpack_public_path__ + "img/bacteria1.0e0c20a6.png";